import { useState } from "react";
import { toast } from "sonner";
import { ScanBarcode, Loader2 } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AssetCapture({ jobId }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);
  if (!["owner", "dispatcher", "technician"].includes(user?.role)) return null;

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file); fd.append("note", "");
      const { data: media } = await api.post(`/jobs/${jobId}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      const { data: r } = await api.post(`/media/${media.id}/extract-serial`);
      if (r.queued) { setLast(r.extracted); toast.success("Serial/model captured - sent to Review for asset record"); }
      else toast.warning(r.warning || "No serial/model detected on that photo");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    setBusy(false); e.target.value = "";
  };

  return (
    <div className="card-tac mt-6 p-5" data-testid="asset-capture">
      <div className="mb-2 flex items-center gap-2 font-mono-tac text-xs uppercase tracking-widest text-slate-500"><ScanBarcode className="h-4 w-4 text-cyan-400" /> Capture serial / model</div>
      <p className="mb-3 text-sm text-slate-400">Snap an equipment nameplate. AI reads the model + serial and files it to the Review queue for your asset records.</p>
      <label data-testid="serial-capture-label" className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-slate-700 px-4 py-2 text-xs text-slate-200 hover:border-cyan-500">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin text-cyan-400" /> : <ScanBarcode className="h-3.5 w-3.5 text-cyan-400" />}
        {busy ? "Reading label…" : "Snap / upload nameplate"}
        <input data-testid="serial-capture-input" type="file" accept="image/*" capture="environment" onChange={onFile} disabled={busy} className="hidden" />
      </label>
      {last && (
        <div className="mt-3 rounded-xl border border-slate-800 bg-[#0d1420] p-3 text-xs text-slate-300" data-testid="serial-capture-result">
          <span className="text-white">{last.manufacturer} {last.model}</span> · serial <span className="font-mono-tac text-emerald-400">{last.serial || "n/a"}</span> - queued for review
        </div>
      )}
    </div>
  );
}
